var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social icon / Apple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8169 10.534C15.8081 8.90076 16.537 7.668 18.0122 6.76012C17.1868 5.56297 15.9399 4.90432 14.2934 4.77526C12.7348 4.65065 11.0313 5.69648 10.4078 5.69648C9.74925 5.69648 8.23891 4.81976 7.05347 4.81976C4.60357 4.85981 2 6.80018 2 10.7477C2 11.9137 2.21074 13.1182 2.63223 14.3614C3.19422 15.9947 5.22263 20 7.33886 19.9332C8.44527 19.9065 9.22678 19.1366 10.6669 19.1366C12.063 19.1366 12.7875 19.9332 14.0212 19.9332C16.155 19.9021 17.9902 16.2617 18.5259 14.6239C15.6633 13.2577 15.8169 10.6186 15.8169 10.534ZM13.3319 3.22652C14.5305 1.7846 14.4207 0.47174 14.3856 0C13.3275 0.0623053 12.1026 0.729862 11.4045 1.55318C10.6361 2.43436 10.1839 3.5247 10.2805 4.753C11.4264 4.84201 12.4714 4.24566 13.3319 3.22652Z",
    fill: "#F0F0F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.81d8a9449e435f6f089e1feb200d5c97.svg";
export { ForwardRef as ReactComponent };